import {useCallback, useMemo} from 'react'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {useQueryLoader, type PreloadedQuery, type UseQueryLoaderLoadQueryOptions} from 'react-relay'
import type {GraphQLTaggedNode, OperationType, PreloadableConcreteRequest, VariablesOf} from 'relay-runtime'
import {getDefaultValues} from '../helpers'

export function useCacheQueryLoader<TQuery extends OperationType>(
  preloadableRequest: GraphQLTaggedNode | PreloadableConcreteRequest<TQuery>,
  initialQueryReference?: PreloadedQuery<TQuery> | null,
  ttl?: number,
): ReturnType<typeof useQueryLoader<TQuery>> {
  const [queryRef, queryLoader, disposeFn] = useQueryLoader<TQuery>(preloadableRequest, initialQueryReference)

  const defaultValues = useMemo(() => getDefaultValues(preloadableRequest), [preloadableRequest])

  const loaderWithCache = useCallback(
    (variables: VariablesOf<TQuery>, options?: UseQueryLoaderLoadQueryOptions) => {
      queryLoader(variables, {
        ...options,
        networkCacheConfig: {
          ...options?.networkCacheConfig,
          metadata: {
            ...options?.networkCacheConfig?.metadata,
            ttl,
            defaultValues,
          },
        },
      })
    },
    [queryLoader, ttl, defaultValues],
  )

  return [queryRef, loaderWithCache, disposeFn]
}
